<template>
    <kiosk-layout formContainer>
        <step-form-heading :icon="faFileLines"> New Terms &amp; Conditions </step-form-heading>

        <form-wrapper
            :sections="[
                { id: 'title', label: 'Title' },
                { id: 'description', label: 'Description' },
                { id: 'content', label: 'Content' },
                { id: 'effective-at', label: 'Effective' },
                { id: 'consent', label: 'Consent' },
            ]"
        >
            <term-form-title id="title" v-model="data" :can-edit="true" />
            <term-form-description id="description" v-model="data" :can-edit="true" />
            <term-form-content id="content" v-model="data" :can-edit="true" />
            <term-form-effective-at id="effective-at" v-model="data" :can-edit="true" />
            <term-form-consent id="consent" v-model="data" :can-edit="true" />

            <vx-sticky-footer>
                <vx-button :href="backHref" class="w-20" size="lg" color="muted">Cancel</vx-button>
                <vx-button
                    @click="submit()"
                    data-test="submit-button"
                    class="grow"
                    size="lg"
                    color="primary"
                    :loading="processing"
                >
                    Create Terms
                </vx-button>
            </vx-sticky-footer>
        </form-wrapper>
    </kiosk-layout>
</template>

<script lang="ts" setup>
import { VxButton, VxStickyFooter } from '@voxie/frontend-components';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons';
import FormWrapper from '~/components/general/FormWrapper.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import TermFormTitle from './TermFormTitle.vue';
import TermFormDescription from './TermFormDescription.vue';
import TermFormContent from './TermFormContent.vue';
import TermFormEffectiveAt from './TermFormEffectiveAt.vue';
import TermFormConsent from './TermFormConsent.vue';
import { useTermFormSubmission } from './useTermFormSubmission';

const props = defineProps<{
    teamId: number;
}>();

const { data, submit, processing, backHref } = useTermFormSubmission(props.teamId, null);
</script>
